// extracted by mini-css-extract-plugin
module.exports = {"container":"settings-actions_container__2egKO","inner":"settings-actions_inner__3mwar","change":"settings-actions_change__1UWQp"};